<template>
  <div class="moow-master-container">
    <div class="container">
      <b-row class="mt-3 mb-4">
        <b-col lg="1" md="1" sm="1"></b-col>
        <b-col xl="7" lg="7" md="7" sm="10" cols="10">
          <md-steppers :md-active-step.sync="active" md-linear class="transparent-back">
            <md-step
              :md-editable="false"
              class="booking-step-container"
              id="reviewStep"
              :md-label="i18n_local.review_details"
              :md-error="reviewStepErr"
              :md-done.sync="reviewStep"
            >
              <md-card class="island-card">
                <md-card-header>
                  <div class="md-title">{{i18n_local.property | capitalize}}</div>
                </md-card-header>
                <md-card-content>
                  <div v-if="!loadingListing">
                    <capacity-preview :listing="listingSafe"></capacity-preview>
                  </div>
                </md-card-content>
              </md-card>

              <md-card class="island-card">
                <md-card-header>
                  <div class="md-title">{{i18n_local.house_rules | capitalize}}</div>
                </md-card-header>
                <md-card-content>
                  <house-rules ref="houseRulesFormRef" :readonly="true" :selectable="false" :rules="houseRules" />
                </md-card-content>
              </md-card>
              <!-- <md-button :disabled="true" v-if="loadingListing" class="md-icon-button">
                <md-icon>
                  <div class="loader-rolling-local"></div>
                </md-icon>
              </md-button> -->
              <!-- <md-button
                class="md-primary md-raised play-cta-button makeup"
                v-else
                style="float:right"
                @click="takeStepForward('reviewStep', 'applicationStep')"
              >Next</md-button> -->
              <moow-button
                :type="['light']"
                :btnText="i18n_local.next"
                class="ml-3"
                :loading="loadingListing"
                @mClick="takeStepForward('reviewStep', 'applicationStep')"
              />
            </md-step>

            <md-step
              :md-editable="false"
              id="applicationStep"
              class="booking-step-container"
              :md-label="i18n_local.application"
              :md-error="applicationStepErr"
              :md-done.sync="applicationStep"
            >
              <md-card class="island-card" v-if="accountPrivatePersonId">
                <md-card-header>
                  <div class="md-title">{{i18n_local.tenant}}</div>
                  <p class="moow-info-txt">{{i18n_local.representative}}</p>
                </md-card-header>
                <md-card-content>
                  <person-view :personId="accountPrivatePersonId" personType="private"></person-view>
                </md-card-content>
              </md-card>

              <md-checkbox
                v-model="userHasSelectedJurPersonOption"
                v-if="accountJuridicalPersonId"
              >{{i18n_local.tenant_is_company}}</md-checkbox>

              <md-card
                class="island-card"
                v-if="accountJuridicalPersonId && userHasSelectedJurPersonOption"
              >
                <md-card-header>
                  <div class="md-title">Tenant</div>
                  <p class="moow-info-txt">Company</p>
                </md-card-header>
                <md-card-content>
                  <person-view :personId="accountJuridicalPersonId" personType="juridical"></person-view>
                </md-card-content>
              </md-card>

              <!-- <router-link to="account" class="footer-nav-item">Edit Identity</router-link> -->

              <md-card class="island-card half">
                <md-card-header>
                  <div class="md-title">{{i18n_local.guests}}</div>
                  <p>{{i18n_local.guests_desc}}</p>
                </md-card-header>
                <md-card-content>
                  <guests-block v-model="guests"></guests-block>
                </md-card-content>
              </md-card>

              
              <!-- <md-button
                class="md-primary md-raised play-cta-button-flat grey"
                @click="takeStepBack('applicationStep', 'reviewStep')"
              >Back</md-button> -->
              <moow-button
                :type="['link', 'dark']"
                :btnText="i18n_local.back"
                class="ml-3"
                @mClick="takeStepBack('applicationStep', 'reviewStep')"
              />
              <moow-button
                :type="['light']"
                :btnText="i18n_local.confirm"
                style="float:right"
                class="ml-3"
                @mClick="agreeToTermsStepForward('applicationStep', 'paymentStep')"
              />
              <!-- <md-button
                class="md-primary md-raised play-cta-button makeup"
                style="float:right"
                @click="agreeToTermsStepForward('applicationStep', 'paymentStep')"
              >Confirm</md-button> -->
            </md-step>

            <md-step
              :md-editable="false"
              id="paymentStep"
              :md-label="i18n_local.payment"
              :md-done.sync="paymentStep"
            >
              <md-card class="attention-card md-primary island-card">
                <div class="md-layout">
                  <div class="md-layout-item md-size-10">
                    <md-button class="md-icon-button md-raised md-primary">
                      <md-icon>notification_important</md-icon>
                    </md-button>
                  </div>
                  <div class="md-layout-item md-size-90">
                    <span>{{i18n_local.reminder_booking_fee_refund}}</span>
                  </div>
                </div>
              </md-card>
              <!--  PRICING -->
              <md-card class="island-card" v-if="!bookingExists">
                <md-card-header>
                  <div class="md-title">{{i18n_local.payment_timeline}}</div>
                </md-card-header>
                <md-card-content>
                  <payment-timeline
                    :terms="dealMask.contractDetails.terms"
                    v-if="dealMask"
                    dueNow="booking"
                    :renderAsExpanded="true"
                  ></payment-timeline>
                </md-card-content>
              </md-card>

              <md-card class="island-card" v-if="!bookingExists">
                <md-card-header>
                  <div class="md-title">{{i18n_local.payment_method}}</div>
                  <p class="payment-information-txt">
                    {{i18n_local.to_complete_booking}}
                    <br />
                    {{i18n_local.you_will_be_charged}}
                    <span v-if="loadingPaymentOptions">
                      <div
                        v-if="loadingPaymentOptions"
                        class="loader-rolling-local_blue"
                        style="width: 25px;"
                      ></div>
                    </span>
                    <span v-else>{{chargedAmount}}{{currencySign}}</span>
                    {{i18n_local.for_booking_fee}}
                  </p>
                </md-card-header>
                <md-card-content>
                  <div
                    v-if="loadingPaymentOptions"
                    class="loader-rolling-local_blue"
                    style="width: 25px;"
                  ></div>
                  <div v-else>
                    <b-row class="payments-container">
                      <b-col
                        class="payment-container"
                        v-for="(bankLinkOption, id) in bankLinkOptions"
                        :key="id"
                      >
                        <a :href="bankLinkOption.url">
                          <div
                            class="payment-option"
                            v-bind:style="{ 'background-image': 'url(' + bankLinkOption.logo_url + ')' }"
                          ></div>
                        </a>
                      </b-col>
                    </b-row>
                  </div>
                </md-card-content>
              </md-card>

              <md-card class="island-card" v-if="bookingExists">
                <md-card-header>
                  <div class="md-title">Already Booked</div>
                  <span>Visit booking to see details</span>
                </md-card-header>
                <md-card-actions>
                  <!-- <md-button
                    class="md-primary md-raised play-cta-button makeup"
                    @click="goToBooking()"
                  >
                    <span>Go To Booking</span>
                  </md-button> -->
                  <moow-button
                    :type="['light']"
                    :btnText="i18n_local.go_to_booking"
                    class="ml-3"
                    @mClick="goToBooking()"
                  />
                </md-card-actions>
              </md-card>
            </md-step>
          </md-steppers>
        </b-col>

        <!--  SIDE BAR -->
        <b-col xl="3" lg="7" md="3" sm="10" cols="10">
          <b-row>
            <b-col>
              <md-progress-spinner
                v-if="loadingListing"
                :md-diameter="30"
                :md-stroke="3"
                md-mode="indeterminate"
              ></md-progress-spinner>

              <md-card v-else class="island-card">
                <!-- <md-card-media-cover md-solid>
                  <md-card-media md-ratio="4:3">
                    <img :src="listingImgPlaceholder" alt="" />
                  </md-card-media>
                </md-card-media-cover> -->
                 <md-card-area>
                    <md-card-header>
                      <span class="md-title clickable" @click="openInNewTab()">{{listingTitle}}</span>
                      <span class="md-subhead">{{listingAddress}}</span>
                    </md-card-header>
                  </md-card-area>
              </md-card>

              <md-card class="island-card">
                <md-card-content>
                  <deal-terms-list v-if="dealMask" :terms="dealMask.contractDetails.terms" />
                </md-card-content>
              </md-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="1" md="1" sm="1"></b-col>
      </b-row>
    </div>

    <md-dialog :md-active.sync="showTermsDialog">
      <terms-conditions @makeDecision="closeTermsDialog" :requireBottom="false"></terms-conditions>
    </md-dialog>
  </div>
</template>

<script>
import { getPricingRules } from "../../pricing/repository/pricingRepository.js";
import {
  calcMoowleBookingFee,
  calcTotalDealWorth
} from "../../pricing/pricingCalculator.js";
// import { nationalityList, monthList } from "../../lists.js";
const lists = require("@/lists.js");

import { createBADeal } from "../../bookings/bookingsService.js";
import { getCleaningFee, getDeposit } from "../../bookings/bookingUtil.js";
import { getUserPublicByUId, getMonth } from "../../functions.js";
import { updateUser } from "../../users/services/userService.js";
import { removeTimezoneReturnAsString } from "../../timeFunctions.js";
import {
  isUserMoowleVerified,
  getUserUid
} from "../../users/repositories/userRepository.js";
import CapacityPreview from "../listingComponents/propertyCapacityPreview.vue";
import PaymentTimeline from "@/components/payments/dealPaymentTimeline.vue";

import { getFormattedAddress } from "../../listings/location/locationService.js";
import BookingOverview from "./bookingOverview.vue";
import TenantDetailsForm from "../../components/bookings/tenantForm.vue";
import TermsConditions from "../../components/dialogs/TermsAndConditions";
import { getListingPublic } from "../../listings/repository/listingRepository";
import {
  idCodeTo_DDMonthYYYY,
  idCodeToDate
} from "@/utils/other/services/identityService.js";
import { convertSuitableListToHouseRules } from "../../platform/utils/property/propertyUtil";
import HouseRules from "@/components/listingComponents/houseRulesSelector.vue";
import GuestsBlock from "@/components/bookings/deals/GuestsBlock.vue";
import PersonView from "@/components/person/personView.vue";
import { mapActions } from "vuex";
import DealTermsList from "@/components/bookings/deals/dealTermsList.vue";
import { mapGetters } from "vuex";
export default {
  name: "bookingApplication",
  props: {
    bookingRequest: {
      //For securitsy reasons this object should not be binded to any DOM value or changed during this stage. These values are set previously in the negotiation phase.
      type: Object,
      required: true
    }
  },
  components: {
    DealTermsList,
    CapacityPreview,
    PaymentTimeline,
    TenantDetailsForm,
    TermsConditions,
    HouseRules,
    GuestsBlock,
    PersonView
  },
  data() {
    return {
      userHasSelectedJurPersonOption: false,
      validForm: false,
      months: lists.monthList,
      nationalities: lists.nationalityList,
      listingUrl: "#",
      chargedAmount: "",
      rent: "",
      guests: [],
      deposit: "",
      cleaningFee: "",
      listingCoverImg: "",
      listingAddress: "",
      listingTitle: "",
      active: "reviewStep",
      reviewStep: false,
      applicationStep: false,
      paymentStep: false,
      applicationStepErr: null,
      reviewStepErr: null,
      tenantWorkOrStudyErr: null,
      ownerAvatar: "",
      ownerFirstName: "",
      loadingListing: true,
      currencySign: "€",
      nrOfBathrooms: 0,
      nrOfBedrooms: 0,
      storages: [],
      balconies: [],
      wcAndBathSeparated: true,
      nrOfGuestsInListing: 0,
      ownerIsVerified: false,
      nrOfGuestsComing: 0,
      tenant: {
        dobYear: undefined,
        dobMonth: undefined,
        dobDay: undefined,
        phone: undefined,
        gender: undefined,
        nationality: undefined,
        email: undefined,
        firstName: undefined,
        lastName: undefined,
        idCode: undefined,
        stayComment: undefined
      },
      updateUserObject: {},
      userOriginalEmail: "",
      showTermsDialog: false,
      agreedTerms: false,
      activeApplicationStep: "personalDetails",
      personalDetailsStep: false,
      additionalDetailsStep: false,
      listing: {},
      loadingPaymentOptions: true,
      bankLinkOptions: [],
      listingSafe: {},
      bookingExists: false,
      existingBookingId: "",
      bookingIdCreatedInBackend: "",
      dealMask: undefined
    };
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    listingImgPlaceholder() {
      // if(listingCoverImg)return listingCoverImg
      return require("../../assets/placeholder.png");
    },
    defaultConnectedAccountId() {
      return this.$store.getters.connectedAccountIds[0];
    },
    houseRules() {
      if (this.listing && this.listing.techDet) {
        return convertSuitableListToHouseRules(
          this.listing.techDet.suitable,
          this.listing.techDet.amenities
        );
      } else return null;
    },
    usersPrivatePersonName() {
      if (this.$store.getters.privatePerson) {
        return (
          this.$store.getters.privatePerson.givenName +
          " " +
          this.$store.getters.privatePerson.surname
        );
      }
      return "";
    },
    usersPrivatePersonEmail(){
      if (this.$store.getters.privatePerson) return this.$store.getters.privatePerson.emails[0]
      return ""
    },
    usersPrivatePersonPhone(){
      if (this.$store.getters.privatePerson) return this.$store.getters.privatePerson.phones[0]
      return ""
    },
    accountPrivatePersonId() {
      if (this.$store.getters.privatePerson)
        return this.$store.getters.privatePerson._id;
      return null;
    },
    accountJuridicalPersonId() {
      if (this.$store.getters.jurPersons && this.$store.getters.jurPersons[0])
        return this.$store.getters.jurPersons[0]._id;
      return null;
    }
  },
  watch: {},
  created() {
    this.$emit("emitChangeViewTitle", "Book the place");
    this.$store.dispatch("editUserViewRole", "tenant")

    this.nrOfGuestsComing = parseInt(this.bookingRequest.nrOfGuests);
    this.verifyBookingRequestOrFallBack(this.bookingRequest);
    this.listingCoverImg = this.listingImgPlaceholder;
    let listingPromise = this.getListing(this.bookingRequest.listingMaaklerId);
    let rulesPromise = this.getPricingRules();

    Promise.all([listingPromise, rulesPromise])
      .then(results => {
        this.listing = results[0];
        this.$store.commit('UPDATE_FEES', this.listing.fees || {});
        this.mapListingDataToUI(results[0]);
        this.setPricingDetails(this.bookingRequest, results[0], results[1]);
        this.guests.push({ name: this.usersPrivatePersonName, email: this.usersPrivatePersonEmail, seq: 0 });
        this.loadingListing = false;
      })
      .catch(err => {
        console.log("BA | err:", err);
        this.fallBackToPreviousView("Cannot get listing or rules");
      });
  },
  mounted() {},
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    currency: value => {
      if (value == "eur") return "€";
      else if (value == "gbp") return "£";
      else return "$";
    }
  },
  methods: {
    ...mapActions("propertyCalendarModule", ["checkAvailability"]),
    openInNewTab() {
      window.open(this.listingUrl, "_blank");
    },
    closeTermsDialog(decision) {
      this.showTermsDialog = false;
      this.agreedTerms = decision;
      if (decision) {
        this.takeStepForward("applicationStep", "paymentStep");
        this.confirmApplication();
      }
    },
    calcMoowleBookingFee(bookingRequest, pricingRules) {
      var totalWorth = calcTotalDealWorth(bookingRequest.agreedDeal);
      return calcMoowleBookingFee(totalWorth, pricingRules, this.listing.fees);
    },
    verifyBookingRequestOrFallBack(request) {
      if (!request) this.fallBackToPreviousView("Request not found");
      if (!request.periodStart)
        this.fallBackToPreviousView("Move in date not found");
      if (!request.periodEnd)
        this.fallBackToPreviousView("Move out date not found");
      if (!request.listingMaaklerId)
        this.fallBackToPreviousView("Listing id not found");
    },
    getPricingRules() {
      return new Promise((resolve, reject) => {
        getPricingRules()
          .then(data => {
            if (data) resolve(data);
            else reject();
          })
          .catch(error => {
            reject();
          });
      });
    },
    getListing(listingMaaklerId) {
      return new Promise((resolve, reject) => {
        getListingPublic(listingMaaklerId)
          .then(listing => {
            if (listing) resolve(listing);
            else reject("not found");
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getUserPublic(uid) {
      return new Promise((resolve, reject) => {
        getUserPublicByUId(uid)
          .then(user => {
            if (user) resolve(user);
            else reject();
          })
          .catch(error => {
            reject();
          });
      });
    },
    mapListingDataToUI(data) {
      this.listingSafe = data;
      this.listingCoverImg = this.getCoverImage(data.marketingDet.images);
      this.listingUrl = "/#/listing/" + data.maaklerID;

      this.listingTitle = data.marketingDet.shortDesc;
      this.listingAddress = getFormattedAddress(data.location);
      //remove permitted policies depending on allowed rules in listing

      this.nrOfBathrooms = data.techDet.nrOfBathrooms;
      this.nrOfBedrooms = data.techDet.nrOfBedrooms;
      this.storages = data.techDet.storage;
      this.balconies = data.techDet.balcony;
      this.wcAndBathSeparated = new Boolean(data.techDet.wcAndBathSeparated);
      this.nrOfGuestsInListing = data.techDet.nrOfGuests;
    },
    setPricingDetails(bookingRequest, listing, pricingRules) {
      var periodicPayments = bookingRequest.agreedDeal.priceTier == "month";
      if (bookingRequest.currency == "eur") this.currencySign = "€";

      this.deposit = getDeposit(bookingRequest, listing);
      this.cleaningFee = getCleaningFee(bookingRequest, pricingRules, listing);

      var additionalFees = [];
      this.cleaningFee
        ? additionalFees.push({ cleaningFee: this.cleaningFee })
        : void 0;

      this.dealMask = this.createDealMask(
        this.bookingRequest,
        this.deposit,
        additionalFees
      );
    },
    createDealMask(bookingRequest, deposit, additionalFees) {
      // Used to pass to deal-terms-list before actuall BA has been created.
      var dealMask = {
        contractDetails: {
          terms: {
            periodEnd: new Date(bookingRequest.periodEnd).toISOString(),
            periodStart: new Date(bookingRequest.periodStart).toISOString(),
            deposit: deposit,
            additionalFees: additionalFees,
            currency: bookingRequest.currency
          }
        }
      };
      var price;
      if (bookingRequest.agreedDeal.priceTier == "month") {
        dealMask.contractDetails.terms.monthly = true;
        dealMask.contractDetails.terms.price = this.bookingRequest.agreedDeal.rentMonthly;
      } else {
        dealMask.contractDetails.terms.monthly = false;
        dealMask.contractDetails.terms.price = this.bookingRequest.agreedDeal.rentDaily;
      }
      return dealMask;
    },
    // TODO: instead, create a mix-in and plug it in
    async checkPropertyAvailability(request) {
      return await this.checkAvailability({
        propertyId: request.propertyId,
        startDate: new Date(request.periodStart).toISOString(),
        endDate: new Date(request.periodEnd).toISOString(),
        termless: false
      });
    },
    async confirmApplication() {
      try {
        this.loadingPaymentOptions = true;
        this.updateUser();
        var request = this.makeCreateBADealRequest();

        const payload = {
          propertyId: request.property._id,
          periodStart: request.contractDetails.terms.periodStart,
          periodEnd: request.contractDetails.terms.periodEnd
        };
        // TODO: Confirm if this check should be done here.
        // if (!(await this.checkPropertyAvailability(payload))) {
        //     this.notifyUser("Selected dates are not available for chosen property");
        //     return;
        // }
        createBADeal(request)
          .then(response => {
            if (response.success && response.message == "exists")
              this.setUpExistingBookingReturnButton(response.result);
            else if (response.success) {
              this.bookingIdCreatedInBackend = this.getBookingIdFromPaymentReturnMsg(
                response.result
              );
              this.populatePaymentOptions(response.result);
            } else {
              this.notifyUser(
                "Something is not right",
                "cannot process payments this time"
              );
            }
            this.loadingPaymentOptions = false;
          })
          .catch(error => {});
      } catch (error) {
        this.notifyUser(
          "An error occurred while checking the property availability for selected dates"
        );
        console.error(error);
      }
    },
    setUpExistingBookingReturnButton(bookingId) {
      this.bookingExists = true;
      this.existingBookingId = bookingId;
    },
    goToBooking() {
      this.$router.push({
        name: "deal",
        params: {
          dealId: this.existingBookingId
        }
      });
    },
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    getBookingIdFromPaymentReturnMsg(bookingPaymentMsg) {
      var bookingId = "";
      var reference = bookingPaymentMsg.reference;
      if (reference.indexOf("bookingId=") != -1) {
        bookingId = reference.substr(10);
      }
      return bookingId;
    },
    populatePaymentOptions(bookingConfirmation) {
      this.chargedAmount = bookingConfirmation.amount;
      this.bankLinkOptions = bookingConfirmation.payment_methods.banklinks;
      this.loadingPaymentOptions = false;
      this.bookingExists = false;
    },
    makeCreateBADealRequest() {
      var pStart = this.getDateAsString(this.bookingRequest.periodStart);
      var pEnd = this.getDateAsString(this.bookingRequest.periodEnd);

      var termless;
      pEnd ? (termless = false) : (termless = true);

      var additionalFees = [];
      this.cleaningFee
        ? additionalFees.push({
            desc: "Cleaning fee",
            amount: Number(this.cleaningFee)
          })
        : void 0;

      var price;
      var monthly = this.bookingRequest.agreedDeal.priceTier == "month";
      monthly
        ? (price = this.bookingRequest.agreedDeal.rentMonthly)
        : (price = this.bookingRequest.agreedDeal.rentDaily);

      // TODO: allow to choose based on the user-person/juridical-person response
      var lesseeRep = "private";
      this.userHasSelectedJurPersonOption
        ? (lesseeRep = "juridical")
        : (lesseeRep = "private");

      return {
        requestId: this.bookingRequest.id,
        lessorAccountId: this.bookingRequest.ownerUid,
        lesseeAccountId: this.defaultConnectedAccountId,
        property: {
          _id: this.listing._id,
          address: this.listing.location.address,
          maaklerID: this.listing.maaklerID
        },
        lesseeRep: lesseeRep,
        contractDetails: {
          terms: {
            periodStart: pStart,
            periodEnd: pEnd,
            termless: termless,
            monthly: monthly,
            deposit: this.deposit,
            additionalFees: additionalFees,
            price: price,
            customPrice: this.bookingRequest.customOffer,
            discounts: this.bookingRequest.agreedDeal.discounts
          },
          nrOfGuests: this.bookingRequest.nrOfGuests,
          guests: this.getGuests(), //this.$refs.guestsSelectorRef.getGuestNames(),
          houseRules: this.houseRules
        }
      };
    },
    getGuests() {
        return this.guests.filter(guest => !!guest.name);
    },
    getCoverImage(images) {
      if (images) {
        let idx = images.findIndex(file => {
          return file.cover == true;
        });
        if (idx > -1) return images[idx].url;
      }
      return this.listingImgPlaceholder;
    },
    takeStepForward(currentStep, nextstep) {
      var stepError = currentStep + "Err";
      if (this.stepDataVerified(currentStep)) {
        this.takeStep(currentStep, nextstep, stepError);
      } else {
        this[stepError] = "Check needed";
      }
    },
    takeStepBack(currentStep, nextstep) {
      this.takeStep(currentStep, nextstep, null);
    },
    agreeToTermsStepForward(currentStep, nextstep) {
      window.scrollTo(0, 0);

      var stepError = currentStep + "Err";
      if (this.stepDataVerified(currentStep)) {
        this.showTermsDialog = true;
      } else {
        this[stepError] = "Check needed";
      }
    },
    takeStep(currentStep, nextStep, stepErr) {
      this[currentStep] = true;
      stepErr ? (this[stepErr] = null) : void 0;
      if (nextStep) this.active = nextStep;
    },
    stepDataVerified(stepId) {
      if (stepId == "applicationStep") {
        return this.verifyApplicationFormData();
      }
      return true;
    },
    verifyApplicationFormData() {
      /*var result = this.$refs.guestsSelectorRef.validateForm();
      return result;*/
      let res = this.validateGuests();
      if(!res) this.notify("Missing info", "specify all guests")
      return res
    },
    validateGuests() {
        if (!this.guests.length) {
            return false;
        }
        for (const guest of this.guests) {
            if (!guest.name) {
                return false;
            }
        }

        return true;
    },
    navigateToChat() {
      this.$router.push("/chat");
    },
    notify(title, message) {
      this.$notify({
        title: title,
        message: message
      });
    },
    fallBackToPreviousView(errMsg) {
      this.notify(errMsg, "going back");
      this.navigateToChat();
    },
    updateUserUpdateObjectFromUI() {
      this.tenant.firstName
        ? (this.updateUserObject.firstName = this.tenant.firstName)
        : void 0;
      this.tenant.lastName
        ? (this.updateUserObject.lastName = this.tenant.lastName)
        : void 0;
      this.tenant.idCode
        ? (this.updateUserObject.idCode = this.tenant.idCode)
        : void 0;
      this.tenant.nationality
        ? (this.updateUserObject.nationality = this.tenant.nationality)
        : void 0;
      this.tenant.gender
        ? (this.updateUserObject.gender = this.tenant.gender)
        : void 0;
      this.tenant.phone
        ? (this.updateUserObject.phone = this.tenant.phone)
        : void 0;
      this.tenant.workOrStudy
        ? (this.updateUserObject.workOrStudy = this.tenant.workOrStudy)
        : void 0;
      this.tenant.placeOfWorkOrStudy
        ? (this.updateUserObject.placeOfWorkOrStudy = this.tenant.placeOfWorkOrStudy)
        : void 0;
      if (this.tenant.email && this.userOriginalEmail != this.tenant.email)
        this.updateUserObject.secondEmail = this.tenant.email;
      if (this.tenant.dobYear && this.tenant.dobMonth && this.tenant.dobDay) {
        var dateOfBirthDate = new Date(
          this.tenant.dobYear,
          this.months.indexOf(this.tenant.dobMonth),
          this.tenant.dobDay
        );
        this.updateUserObject.dob = removeTimezoneReturnAsString(
          dateOfBirthDate
        );
      }
      return this.updateUserObject;
    },
    updateUser() {
      var uuo = this.updateUserUpdateObjectFromUI();
      updateUser(getUserUid(), uuo);
    },
    getDateAsString(date) {
        return (new Date(date)).toISOString().split('T')[0];
    },
  }
};
</script>

<style scoped>
@import "../../assets/styles/global.css";
@import "../../assets/styles/booking.css";

.payment-container {
  margin: 10px;
}

.payment-option {
  height: 62px;
  width: 156px;
  background-repeat: no-repeat;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/bookings/BookingApplication.vue